import React from 'react';

const Messages = () => {
  return (
    <div className="p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>Messages</h1>
        <div className="bg-white border border-slate-200 rounded-2xl p-12 text-center">
          <p className="text-slate-500">Message functionality is similar to apprentice messages</p>
        </div>
      </div>
    </div>
  );
};

export default Messages;
